import React from 'react';
import { ClipboardListIcon, FileSpreadsheetIcon, FlaskConicalIcon, GitBranchIcon, LayersIcon, StethoscopeIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { extras } from '../data/content';
const iconMap = {
  protocol: ClipboardListIcon,
  algorithm: GitBranchIcon,
  lab: FlaskConicalIcon,
  table: FileSpreadsheetIcon,
  special: LayersIcon,
  cases: StethoscopeIcon
};
export function Extras() {
  return <section className="bg-navy-50 py-14 sm:py-20" data-id="element-116" data-mp="yoho5xrz0owi">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-117" data-mp="ylvf1tpfm1c6">
        <SectionHeading eyebrow="Molto più di 6 libri digitali" title="È il tuo sistema di consultazione clinica per la TRT" subtitle="All’interno riceverai anche:" data-id="element-118" data-mp="kp8hbopnn757" />

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-119" data-mp="2f3j8i3tq2de5">
          {extras.map(extra => {
          const Icon = iconMap[extra.icon as keyof typeof iconMap];
          return <article key={extra.title} className="flex h-full flex-col rounded-2xl border border-navy-900/10 bg-white p-5" data-id="element-120" data-mp="108o3yy36hyiw">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-navy-900" data-id="element-121" data-mp="1a020cwzu2i7t">
                  <Icon className="h-5 w-5 text-gold-400" aria-hidden="true" data-id="element-122" data-mp="150foaqvqr80l" />
                </span>
                <h3 className="mt-4 text-[15px] font-black uppercase leading-snug tracking-tight text-navy-900" data-id="element-123" data-mp="hablumuaheb6">
                  {extra.title}
                </h3>
                <p className="mt-2 text-[14px] leading-relaxed text-navy-900/70" data-id="element-124" data-mp="r9atq378d5x4">
                  {extra.text}
                </p>
              </article>;
        })}
        </div>

        <div className="mt-10 rounded-2xl bg-navy-900 p-6 text-center sm:p-8" data-id="element-125" data-mp="mckcvdnlq6an">
          <p className="text-[10px] font-black uppercase tracking-[0.22em] text-gold-400" data-id="element-126" data-mp="22mmu243s76ej">
            Il risultato
          </p>
          <p className="mt-4 text-[15px] font-semibold leading-snug text-white/60 line-through decoration-red-400/70 sm:text-lg" data-id="element-127" data-mp="24stfd7g2ju7x">
            “Dove trovo la risposta a questa domanda?”
          </p>
          <p className="mt-3 text-[18px] font-black uppercase leading-tight tracking-tight text-white sm:text-2xl" data-id="element-128" data-mp="2er0hik5p87pv">
            “Quale percorso si applica a questo paziente?”
          </p>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-129" data-mp="1m2bqxf29rksd">
          <CtaBlock label="Accedi al sistema completo" note="6 volumi · 300+ protocolli · 30+ casi · 19 EUR" data-id="element-130" data-mp="1m3mpn0guy2cm" />
        </div>
      </div>
    </section>;
}